import type { ReactNode } from 'react';

export const symbol_video_camera_back: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M235-333h340q9.21 0 13.1-8 3.9-8-1.1-16l-99-135q-2.29-3-5.33-4.5-3.05-1.5-6.86-1.5-3.81 0-6.72 1.5-2.91 1.5-5.09 4.5l-82 109q-2 3-5.5 4t-6.5 1q-3 0-6.5-1t-5.5-4l-47-60q-2.45-2.86-5.73-3.93Q302-448 299-448q-3 0-6.5 1.5T287-442l-64 85q-5 8-1.1 16 3.89 8 13.1 8Zm-95 173q-24 0-42-18t-18-42v-520q0-24 18-42t42-18h520q24 0 42 18t18 42v215l134-134q7-7 16.5-3.46T880-649v338q0 9.92-9.5 13.46Q861-294 854-301L720-435v215q0 24-18 42t-42 18H140Zm0-60h520v-520H140v520Zm0 0v-520 520Z"
		/>
	</svg>
);
